import http from '../httpService';
import {apiEndpoint} from '../../constants/config.json';

export function postContactUs(contactUsDetail){
    const fullApiEndpoint = apiEndpoint + "/contactus/api/create_new_contact_request";
    //need to write to firebase then the server
    return http.post(fullApiEndpoint,contactUsDetail);
}
